import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=2b82e980&scoped=true"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b82e980",
  null
  
)

export default component.exports